<template>
  <section class="detail-page-container">
    <!-- <div class="top-bar">
      <span>MicroPolicy</span>
    </div> -->
    <section class="main-container">
      <div class="main-header">
        <div>
          <div class="header-title">
            <span
              class="icon light-gray">
              <font-awesome-icon
                :icon="giftId? 'sack-dollar' : 'shopping-bag'"
              />
            </span>
            <h3>{{ detailData.product_nm }}</h3>
            <span class="hcid">Reference <span class="number-color">#{{ detailData.order_sn }}</span></span>
          </div>
          <div>
            <span
              class="span-status green"
              :class="{
                'yellow-dark': detailData.status == 1,
                'green': detailData.status == 2,
              }">
              {{ detailData.status == 1? 'Preparing' : 'Shipped' }}
            </span>
            <span class="header-date">Purchased  <span class="number-color number-fontsize">{{ detailData.created_date }}</span></span>
            <span class="header-date">Updated  <span class="number-color number-fontsize">{{ detailData.updated_at ||  detailData.updated_date}}</span></span>
          </div>
        </div>
      </div>
      <div class="main-body">
        <section class="main-content">
          <order-detail
            v-if="showOrderDetail"
            :isHDRedeem="HDId !== null"
            :form='detailData'></order-detail>
          
          <content-list
            v-if="giftId"
            :detailData="detailData"></content-list>

          <payment-record :form='detailData.payment_record'></payment-record>
        </section>

        <aside>
          <div
            v-if="showShip"
            class="card child-button-block"
            :class="{'bg-yellow': detailData.status == 1, 'bg-green': detailData.status == 2}">
            <span class="label">{{detailData.status == 1? 'Preparing to ship' : 'Shipped'}}</span>
            <p
              v-if="detailData.track_number"
              class="track">{{detailData.track_number}}</p>
            <v-button
              v-show="detailData.status == 1"
              class="g-btn"
              icon="shipping-fast"
              @click="openDialog('tracking-dialog')"
            >Mark as Shipped</v-button>
            <v-button
              v-show="detailData.status == 2"
              icon="pen"
              @click="openDialog('tracking-dialog')"
            >Edit Tracking Number</v-button>
            <v-button
              v-show="detailData.status == 2"
              icon="undo"
              @click="handleRevert"
            >Revert to Preparing</v-button>
          </div>

          <div
            class="box">
            <div class="flex flex-sb">
              <span class="title">Customer</span>
            </div>
            <div  v-if="detailData.customer && detailData.customer.created_at">
              <div class="flex flex-align-center">
                <div class="customer-ava">
                  <img
                    :src="avt_pic"
                    alt="">
                </div>
                <span class="span-status">{{detailData.customer.identity==2?'Company':'Personal'}}</span>
                <router-link
                  :to="{path:'/accounts/detail',query:{customer_id:customerType()}}"
                  class="flex flex-wrap">
                  <span
                    v-if="isShowName"
                    class="plan-name hand">{{ detailData.customer.isrd_nm }} &nbsp;</span>
                  <span
                    v-else
                    class="plan-name hand unname">Unnamed Account &nbsp;</span>
                  <span
                    v-if="detailData.customer.identity!==2&& detailData.customer.nick_name"
                    class="plan-name small hand">({{ detailData.customer.nick_name }})</span>
                </router-link>
              </div>
              <ul>
                <li>
                  <span>Joined</span>
                  <span>{{ detailData.customer.created_at }}</span>
                </li>
                <li>
                  <span>Policy Count</span>
                  <span>{{ detailData.customer.polices }}</span>
                </li>
              </ul>
            </div>
            <template v-else>
              <span class="unname none-data">No customer attached</span>
            </template>
            <contact-customer
              :customerId="detailData.user_id"
              :phone="customer.mobile_no"
              :customerName="customer.isrd_nm"
              :email="customer.email"
            />
          </div>

          <div class="box box-remark">
            <span class="title">Remarks</span>
            <div class="remarks-container">
              <div
                v-for="(item, index) in remarkList"
                :key="index"
                class="remark-box">
                <div class="remark-header">
                  <span>{{ item.cs_name }}</span>
                  <span>{{ item.created_at }}</span>
                </div>
                <p>{{typeof item.message === 'object'? item.message.content: item.message  }}</p>
              </div>
            </div>
            <div class="remark-add">
              <v-input
                v-model="message"
                class="mg-b-15"
                append="Add"
                @handlerAppend="handlerSendRemark"/>
            </div>
          </div>
        </aside>
      </div>
    </section>


    <!-- dialog -->
    <tracking-dialog
      ref="tracking-dialog"
      :num="detailData.track_number"
      :sms="detailData.sms_model"
      :mobile="detailData.mobile_no"
      :customer="detailData.customer"
      @saveTracking='getTracking'></tracking-dialog>
  </section>
</template>
<script>
import {mapActions} from 'vuex'
import MixinOptions from '@/mixins/options'
import OrderDetail from './components/order-detail'
import PaymentRecord from './components/payment-record'
import TrackingDialog from './components/dialog/enter-tracking-number.vue'
import ContactCustomer from '@/views/components/new-contact-customer'
import {getIndicaidDetail, markShipped, editTracking, revertPreparing, addRemark, getRedeemDetail, HDAddRemark, HDMarkShipped, HDEditTracking, HDRevertPreparing, getGiftPackDetail, giftAddRemark} from '@/api/micropolicy'
import ContentList from  './components/content-list'

export default {
  name: 'PurchaseDetail',
  components: {
    OrderDetail,
    PaymentRecord,
    TrackingDialog,
    ContactCustomer,
    ContentList,
  },
  mixins: [MixinOptions],
  data() {
    return {
      detailData: {},
      customer:{},
      formData: {},
      message: '',
      remarkList:[],
      downloadData: {}
    }
  },
  computed: {
    IndicaidID(){
      return this.$route.query.id || null
    },
    avt_pic(){
      return this.detailData.avatar_pic || null
    },
    customerInfo(){
      return this.detailData.customer
    },
    customerType() {
      return type =>{
        const {user_id} =  this.detailData
        let customerId = user_id
        // 一個是 client user
        if(type=='client') {
          customerId = this.detailData.relation.client_user_id
        }
        return  customerId||''
      }
    },
    isShowName(){
      let {customer} = this.detailData
      if(customer.isrd_nm)
        return customer.isrd_nm.trim()!=''
      else return  false
    },
    HDId(){
      return this.$route.query.hdId || null
    },
    giftId(){
      return this.$route.query.giftId || null
    },
    showShip(){
      return !this.giftId
    },
    showOrderDetail(){
      return !this.giftId
    }
  },
  mounted() {
    this.network().getDetail()
  },
  methods: {
    ...mapActions('common', ['setProductId']),
    ...mapActions('quote', ['setAllQuote', 'setQuoteForm', 'setQuoteResult']),
    ...mapActions('account', ['setCustomerId']),

    openDialog(target) {
      this.$refs[target].changeDialog()
    },

    handleRevert(){
      this.network().revertPreparing()
    },

    handlerSendRemark(){
      if(this.message){
        this.network().addRemark()
      }
    },

    getTracking(val){
      if(this.detailData.track_number){
        this.network().editTracking(val)
      }else{
        this.network().markShipped(val)
      }
    },

    network() {
      return {
        getDetail: async ()=> {
          let params = {
            indicaid_id: this.IndicaidID,
            id: this.HDId || this.giftId
          }
          if(this.IndicaidID){
            var {data} = await getIndicaidDetail(params)
          }else if(this.giftId){
            var {data} = await getGiftPackDetail(params)
          }else{
            var {data} = await getRedeemDetail(params)
          }
          this.detailData = data
          this.remarkList = data.remark_list
          this.customer = data.customer
        },

        markShipped: async (val)=> {
          let params = {
            voucher_id: this.HDId,
            indicaid_id: this.IndicaidID
          }
          params = Object.assign(params,val)
          if(this.HDId){
            var {status} = await HDMarkShipped(params)
          }else{
            var {status} = await markShipped(params)
          }
          if(status == 200){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.network().getDetail()
          }
        },

        editTracking: async (val)=> {
          let params = {
            indicaid_id: this.IndicaidID,
            voucher_id: this.HDId
          }
          params = Object.assign(params,val)
          if(this.HDId){
            var { status } = await HDEditTracking(params)
          }else{
            var { status } = await editTracking(params)
          }
          if(status == 200){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.network().getDetail()
          }
        },

        revertPreparing: async ()=> {
          let params = {
            indicaid_id: this.IndicaidID,
            voucher_id: this.HDId
          }
          if(this.HDId){
            var { status } = await HDRevertPreparing(params)
          }else{
            var { status } = await revertPreparing(params)
          }
          if(status == 200){
            this.$refs['tracking-dialog'].resetForm()
            this.network().getDetail()
          }
        },

        addRemark: async ()=> {
          if(this.HDId){
            var { data } = await HDAddRemark({
              voucher_id: this.HDId,
              message: this.message
            })
          }else if(this.giftId){
            var {data} = await giftAddRemark({
              id: this.giftId,
              message: this.message
            })
          }else{
            var { data } = await addRemark({
              indicaid_id: this.IndicaidID,
              message: this.message
            })
          }
          this.message = ''
          this.remarkList.push(data)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.detail-page-container {
  position: relative;
  .flex-wrap{
    flex-wrap: wrap;
    text-decoration: none;
  }
  .top-bar {
    padding-top: 5px;
    color: #409eff;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #409eff;
  }
  .main-container {
    margin-top: 20px;
    .main-header {
      padding: 0 30px 10px;
      .header-title {
        display: flex;
        padding-bottom: 15px;
        align-items: center;
        .icon {
          font-size: 18px;
          &.gray {
            color: #586069;
          }
          &.green {
            color: #22863A;
          }
          &.red {
            color: #D73A49;
          }
          &.light-gray {
            color: #6A737D;
          }
        }
        h3 {
          padding-bottom: 0;
          padding: 0 15px;
          color: #24292E;
        }
        .hcid {
          display: inline-block;
          padding-right: 20px;
          font-size: 16px;
          color: #586069;
          font-weight: 500;
        }
      }
      .span-status {
        display: inline-block;
        margin-right: 15px;
        padding: 5px 10px;
        border-radius: 12px;
        font-size: 12px;
        line-height: 14px;
        color: white;
        font-weight: 500;
        .svg-inline--fa {
          margin-right: 5px;
          font-size: 14px;
        }
      }
      .span-status {
        &.green {
          background: #28a745;
          color: white;
        }
        &.yellow-dark {
          background: #DBAB09;
        }
      }
      .header-date {
        padding-right: 15px;
        font-size: 14px;
        color: #586069;
        font-weight: 500;
      }
      .header-ref{
        font-size: 12px;
        line-height: 18px;
        color: #586069;
        font-weight: 600;
        .number-color{
          font-weight: 400;
        }
      }
      .header-label {
        display: inline-block;
        padding-right: 15px;
        color: #586069;
        font-size: 14px;
        font-weight: 500;
      }
      .top {
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        h1 {
          padding-bottom: 0;
        }
        .company-logo {
          margin-right: 15px;
          height: 42px;
          img {
            height: 42px;
          }
        }
      }
      .info-container {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        border-top: 1px solid #dddfe7;
        & > div {
          font-size: 14px;
          color: #91939a;
          & > span:first-child {
            display: block;
            padding-bottom: 5px;
            font-size: 14px;
            font-weight: bold;
            color: #616266;
          }
        }
      }
    }
    .main-body {
      display: flex;
      padding: 0 30px;
      .main-content {
        flex: 1;
        margin-right: 15px;
      }
      aside {
        width: 280px;
        .bg-yellow{
          background: rgba(255, 251, 221, 1);
        }
        .bg-green{
          background: rgba(220, 255, 228, 1);
        }
        .track{
          margin: 10px 0;
          font-size: 14px;
        }
        .g-btn{
          background: rgba(46, 164, 79, 1);
          color: #fff;
        }
        .box-remark{
          border-bottom: 0!important;
        }
        .box{
          padding: 29.5px 0;
          border-bottom: 1px solid #D1D5DA;
        }
        .plan-name{
          color: #0366D6;
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 0;
        }

        ul {
          margin-top: 15px;
          li {
            display: flex;
            padding: 5px;
            list-style: none;
            color: #606266;
            font-size: 12px;
            line-height: 14px;
            span {
              flex: 1;
            }

            span:first-child {
              font-weight: bold;
            }
          }
          margin-bottom: 15px;
        }
        .span-status{
          border: 1px solid #616266;
          color: #616266;
          padding: 1px 8px;
          border-radius: 50px;
          font-size: 14px;
          margin-right: 10px;
          background: #fff;
        }
        .card {
          margin-bottom: 15px;
        }

        .border-b {
          //margin: 10px -15px 0 -15px;
          padding: 0 15px 10px;
          border-bottom: 1px solid #dddfe7;

          .title {
            margin-bottom: 5px;
          }
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          padding-top: 5px;
          font-size: 14px;
          font-weight: bold;
        }

        .el-input, .el-select {
          margin-bottom: 10px;

          & + .el-button {
            margin-bottom: 10px;
          }
        }
        .flex-align-center{
          align-items: center;
        }
        .customer-ava{
          height: 28px;
          width: 28px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #DBEDFF;
          margin-right: 10px;
          img{
            width: 100%;
            display: block;
            border-radius: 50%;
          }
        }

        .remark-add {
          z-index: 2;
          margin: 0 -15px;
          padding: 15px 15px 0 15px;
          //border-top: 1px solid #dddfe7;
        }

        .remarks-container {
          z-index: 1;
          max-height: 300px;
          overflow-y: auto;

          .remark-box {
            margin-bottom: 10px;
            font-size: 12px;
            color: #91939a;

            .remark-header {
              display: flex;
              justify-content: space-between;

              span:first-child {
                font-weight: bold;
              }
            }

            p {
              padding-bottom: 10px;
              color: #616266;
            }
          }
        }
      }
    }
  }
  .number-color{
    color:#24292E ;
    //font-weight: 480;
  }
  .number-fontsize{
    font-size: 14px;
    font-weight: normal;
  }
  .purple {
    background: #6F42C1;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style: italic;
  }
  .name{
    color: #616266;
  }
}
</style>
